// extracted by mini-css-extract-plugin
export var box = "_5l-0";
export var check = "_5l-1";
export var checkboxButton = "_5l-6";
export var checkboxGroup = "_5l-5";
export var disabled = "_5l-7";
export var ghost = "_5l-9";
export var input = "_5l-2";
export var label = "_5l-4";
export var normal = "_5l-8";
export var uncheck = "_5l-3";